<div class="termsCondition">
    <header>
        <img src="assets/Solv_Logo_new.svg" alt="" srcset="" class="logo" />
        <div class="contact">
            <p>
                <a href="https://www.solvezy.com/contact/" target="_blank">
                    Contact Us
                </a>
            </p>
            <a href="https://play.google.com/store/apps/details?id=com.solv.commerce&referrer=utm_source%3Dwebsite%26utm_medium%3DhomePageCtaButton%26utm_term%3Dinstall" target="_blank">

              <img
                  src="assets/icons/googlePlayStore.png"
                  alt=""
                  srcset=""
                  class="logo"
              />
            </a>
        </div>
    </header>

    <div class="container-box">
        <div>
            <h3 class="text-heading">
                Terms & Conditions for deleting your account:
            </h3>
            <ul class="condition">

             <li> Please note that once you choose to delete your account your account will be no longer be available to you and you will not be able to activate or use the account again.</li>

             <li> If you wish to proceed with the account deletion request, please ensure that you have read and understood the following:</li>

             <li> There are no pending orders, cancellation, returns, refund, utilized Buy Now Pay Later credit limit or any other request.</li>

             <li> You have exhausted and do not intend to use coupon code(s)/discount coupon(s) given to you or associated with your account. Please note that once your account is deleted, you will not be able to access any coupon code(s)/discount coupon(s).</li>

             <li> Solv may refuse deletion of your account in case you have raised grievance related to pending payments to your orders, shipment or deliveries or credit line or if there are any pending orders, cancellation, returns, refund or any other request.</li>

             <li> You will not be able to access or request to access order history Wishlist, saved address, previous orders, invoices, saved or preferred payment methods etc. or use any products or services offered on Solv and will have to create a new account if you have to avail products and services from Solv platform.</li>

             <li> Any data that may have to be retained to fulfil our legal and regulatory obligations/requirements under applicable laws shall be stored as may be required including for tax, accounting and fraud prevention purposes. (mostly until 8 yrs).</li>

             <li> In the event you availed any Buy Now Pay Later credit limit through our financing partner and if the same is active and not utilized we would request you to write to the financial partner directly to close for closure of the credit limit and reinitiate the account deletion process.</li>

             <li> If you are registered as a seller, all your catalogue will be removed and cannot be restored post account deletion.</li>

             <li> If you are registered as a seller and place a request for account deletion, you will not be able to access your account and none of the buyers will be able to purchase your products.</li>



                <li>
                    You acknowledge that you have read our
                    <span>
                        <a
                            href="https://www.solvezy.com/privacy-policy/"
                            target="_blank"
                        >
                            Privacy Policy
                        </a>
                    </span>
                </li>
            </ul>
        </div>
        <div class="contact-email">
            <p>
                Please mail us on
                <span
                    ><a href="mailto: cs@solvezy.com">cs@solvezy.com</a>
                </span>
                to raise an Account Deletion request
            </p>
        </div>
        <div class="metion-details">
            <p>In the mail kindly mention the following details:</p>
            <ul>
                <li>Registered Number</li>
                <li>Business Name</li>
                <li>Solv ID</li>
                <li>Buyer/Seller</li>
                <li>Reason for Deletion</li>
            </ul>
        </div>
    </div>
    <footer class="footer">
        <div class="copeRight">
            <p>Copyright © 2024 All Rights Reserved</p>
        </div>
        <div class="condition">
            <ul>
                <li>Terms Of Services</li>
                <li>Privacy Policy</li>
                <li>Information Security Policy</li>
                <li>POSH Policy</li>
            </ul>
        </div>
    </footer>
</div>
